import script from "./MimicPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MimicPage.vue?vue&type=script&setup=true&lang=js"

import "./MimicPage.vue?vue&type=style&index=0&id=b5821092&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5821092"]])

export default __exports__